import React from 'react';
import { clientData } from '../data/data';

import TinySlider from 'tiny-slider-react';
import '../../node_modules/tiny-slider/dist/tiny-slider.css';
import { Link } from 'react-router-dom';
import { FiInstagram, FiLinkedin } from 'react-icons/fi';
import { RiTwitterXFill } from 'react-icons/ri';
import { TfiWorld } from 'react-icons/tfi';
import { useTranslation } from 'react-i18next';

interface ClientData {
  image: string;
  name: string;
  position: string;
  position2?: string;
  linkedin?: string;
  twitterx?: string;
  instagram?: string;
  website?: string;
}

export default function Client() {
  const { t } = useTranslation();

  const settings = {
    container: '.tiny-three-item',
    controls: false,
    nav: true,
    mouseDrag: true,
    touch: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    speed: 400,
    gutter: 12,
    responsive: {
      992: { items: 3 },
      767: { items: 2 },
      320: { items: 1 },
    },
  };

  return (
    <div className="grid grid-cols-1 mt-6">
      <div className="tiny-three-item">
        <TinySlider settings={settings}>
          {clientData.map((item, index) => (
            <div className="tiny-slide text-center" key={index}>
              <div className="text-center mt-5">
                <img src={item.image} className="size-36 rounded-full shadow-md mx-auto" alt="" />
                <h6 className="mt-5 font-semibold">{t(item.name)}</h6>
                <div className="flex flex-col gap-1">
                  <span className="text-slate-500 text-sm">{t(item.position)}</span>
                  {item.company && (
                    <Link
                      to={item.companyLink}
                      className="text-slate-400 text-sm"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(item.company)}
                    </Link>
                  )}
                  {item.position2 && (
                    <span className="text-slate-400 text-sm">{t(item.position2)}</span>
                  )}
                </div>
                <div className="mt-3">
                  <ul className="list-none mb-0 flex justify-center gap-4">
                    {item.linkedin && (
                      <li>
                        <Link to={item.linkedin} target="_blank" rel="noopener noreferrer">
                          <FiLinkedin className="inline size-5 text-amber-400 hover:underline" />
                        </Link>
                      </li>
                    )}
                    {item.twitterx && (
                      <li>
                        <Link to={item.twitterx} target="_blank" rel="noopener noreferrer">
                          <RiTwitterXFill className="inline size-5 text-amber-400 hover:underline" />
                        </Link>
                      </li>
                    )}
                    {item.instagram && (
                      <li>
                        <Link to={item.instagram} target="_blank" rel="noopener noreferrer">
                          <FiInstagram className="inline size-5 text-amber-400 hover:underline" />
                        </Link>
                      </li>
                    )}
                    {item.website && (
                      <li>
                        <Link to={item.website} target="_blank" rel="noopener noreferrer">
                          <TfiWorld className="inline size-5 text-amber-400 hover:underline" />
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </TinySlider>
      </div>
    </div>
  );
}
